'use client';

import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { Text } from '@portals/ui-kit';
import { useLocalStorage } from '@portals/external-services-header/lib/_hooks/use-local-storage';
import { EButtonColor } from '@/_kit/button/_types';
import { ELoginButtonPagePosition } from '@/_constants/analytics';
import { LoginButton } from '../login-button';
import { Slider } from './_components/slider';
import { TPreviewConfig } from './_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Preview';

export const Preview = ({
  title,
  startSelling,
  buttonTitle,
  slides,
}: TPreviewConfig) => {
  const translations = useTranslations();
  const { mobileWebView } = useLocalStorage();

  return (
    <section
      className={cn(BLOCK_NAME, {
        [`${BLOCK_NAME}--mobile-web-view`]: mobileWebView,
      })}
    >
      <div className={cn(`${BLOCK_NAME}__content-wrapper`)}>
        <div className={cn(`${BLOCK_NAME}__content`)}>
          <div className={cn(`${BLOCK_NAME}__title`)}>
            <Text
              tagType="h1"
              color="inherit"
              size="headline-l"
              text={translations(title)}
            />
          </div>
          <div className={cn(`${BLOCK_NAME}__description`)}>
            <Text
              color="inherit"
              size="title-s"
              text={translations(startSelling)}
            />
          </div>
          <div className={cn(`${BLOCK_NAME}__button`)}>
            <LoginButton
              color={EButtonColor.PINK}
              positionOnPage={ELoginButtonPagePosition.UP}
              text={translations(buttonTitle)}
            />
          </div>
          <div>
            <div className={cn(`${BLOCK_NAME}__gradient`)} />
            <div className={cn(`${BLOCK_NAME}__square-wrapper`)}>
              <div className={cn(`${BLOCK_NAME}__square`)} />
            </div>
            <Slider slides={slides} />
          </div>
        </div>
      </div>
    </section>
  );
};
